import React from "react";

/**
 * Custom anchor component for ReactMarkdown to ensure external links are secure
 */
export const SecureAnchor: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = ({ href, children, ...props }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
    {children}
  </a>
);
